/**
 * Constants
 *
 * Global constants used throughout the application
 */

import { LLMID } from '@/types'
import { CHAT_SETTING_LIMITS as OriginalChatSettingLimits } from '@/lib/chat-setting-limits'

// Re-export the chat setting limits
export const CHAT_SETTING_LIMITS = OriginalChatSettingLimits

// Portkey gateway URL
export const PORTKEY_GATEWAY_URL = 'https://api.portkey.ai'

/** Defer focus until after layout/popover has settled (e.g. dropdown open, modal mount) */
export const UI_FOCUS_DEFER_MS = 100
